export const EDS_FILTER_ASSIGNEE_UNASSIGNED_VALUE = 'null';

export const EDS_FILTER_ASSIGNEE_UNASSIGNED_LABEL = 'Unassigned';
